import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Australian() {
  return (
    <ApiCommunityDirectoryPage
      community="Australian"
      eyebrow="Australian community guide"
      title="Australian favorites, businesses, and local essentials in San Antonio."
      
      tags={["Australian community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Australian community guide?"
      modalIdPrefix="australian-directory"
    />
  );
}
